import { useRouter } from 'next/router';
import { getRealLocale } from 'utils/helpers';
import { getBlogListing as apiGetBlogListing } from 'services/blog';
import useSWR from 'swr';

export default function useBlog(initialData, page, categoryId) {
  const router = useRouter();
  const locale = getRealLocale(router.locale);
  const url = `${locale}/api/v1/blog`;
  const fetcher = () => apiGetBlogListing(locale, categoryId, page).then((res) => res.data);

  const { data: blogData, error, mutate } = useSWR([url, locale, categoryId, page], fetcher, { initialData });

  return {
    mutate,
    url,
    blogData: blogData ? blogData : { ...initialData },
    error,
  };
}
